import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function Rolemanagement() {

    const [modal3, setmodal3] = useState(false);
    const [editrolemodal, seteditrolemodal] = useState(false);
    const editroletoggle = () => {
        seteditrolemodal(!editrolemodal);
    }
    const toggle3 = () => {
        setmodal3(!modal3);
    }
    return (

        <div>
            <div>
                <ol className="breadcrumb float-xl-right">
                    <li className="breadcrumb-item"><a href="/dashboard/home">Home</a></li>
                    <li className="breadcrumb-item active">Role management</li>
                </ol>
                <h1 className="page-header">Role management</h1>
                <Panel className='mt-2'>
                    <PanelHeader>
                        <div className='d-md-flex align-items-center'>
                            <h4 className='mb-0 text-light'>
                                Role management List
                            </h4>

                            <button
                                type="button"
                                className="btn btn-primary mx-md-3 mt-0 mt-sm-2 btn-sm shadow-add"
                                onClick={toggle3}
                            >
                                Add new
                            </button>
                        </div>

                    </PanelHeader>
                    <PanelBody>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="table-responsive">
                                        <table className="table m-b-0 table-bordered table-striped text-center">
                                            <thead>
                                                <tr>
                                                    <th>Sr.No</th>
                                                    <th>Role management List</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Designer </td>
                                                    <td>
                                                        <div style={{ width: '100px' }}>
                                                            <button
                                                                onClick={editroletoggle}
                                                                type="button"
                                                                className="btn btn-primary mx-1 btn-sm"
                                                            >
                                                                <i className="ion ion-md-create "></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm" >
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Product Manager</td>
                                                    <td style={{ width: '100px' }}>
                                                        <div style={{ width: '100px' }}>
                                                            <button
                                                                onClick={editroletoggle}
                                                                type="button"
                                                                className="btn btn-primary mx-1 btn-sm"
                                                            >
                                                                <i className="ion ion-md-create "></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm" >
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Sourcing Manager</td>
                                                    <td>
                                                        <div style={{ width: '100px' }}>
                                                            <button
                                                                onClick={editroletoggle}
                                                                type="button"
                                                                className="btn btn-primary mx-1 btn-sm"
                                                            >
                                                                <i className="ion ion-md-create "></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm" >
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PanelBody>
                </Panel>

            </div>
            <Modal isOpen={modal3} toggle={toggle3} >
                <ModalHeader toggle={toggle3} className="modalheader"><h5 className='text-white mb-0'>Add New Role</h5></ModalHeader>
                <ModalBody>

                    <form action="" method="POST" className="m-b-30">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Role management Name</label>
                            <div className="input-group row justify-content-center">
                                <input type="text"
                                    className="form-control col-sm-11"
                                    placeholder="Enter Name"

                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="button" className="btn btn-sm btn-danger m-r-10  shadow-add ">Discard</button>
                            <button type="button" className="btn btn-sm btn-primary shadow-add ">Create role</button>

                        </div>
                    </form>
                </ModalBody>

            </Modal>
            <Modal isOpen={editrolemodal} toggle={editroletoggle} >
                <ModalHeader toggle={editroletoggle} className="modalheader"><h5 className='text-white mb-0'>Edit New Role</h5></ModalHeader>
                <ModalBody>

                    <form action="" method="POST" className="m-b-30">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Role management Name</label>
                            <div className="input-group row justify-content-center">
                                <input type="text"
                                    className="form-control col-sm-11"
                                    placeholder="Enter Name"

                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="button" className="btn btn-sm btn-danger m-r-10  shadow-add ">Discard</button>
                            <button type="button" className="btn btn-sm btn-primary shadow-add ">Create role</button>

                        </div>
                    </form>
                </ModalBody>

            </Modal>
        </div>
    )

}

export default Rolemanagement;